export default __webpack_public_path__ + "static/media/WorkSans-Light.f78db015.eot";